export enum RangeIds {
  // Location maps
  AbdominalPain = "FE.9d9be449-1d2f-4ac7-b30b-882ef8eb83e7",
  Skin = "FE.fcbdc41b-8ad1-442e-9a77-72116b9dd0fb",
  SkinFace = "FE.aa3460a5-fd03-494f-98aa-0827b33b6351",
  SkinLowerLimb = "FE.6fe9195a-327a-4b2c-9194-fa9377e7e543",
  SkinFrontalArea = "FE.e6219861-eb3a-4bbe-a4ca-cfd5b25b8dda",
  SkinBackArea = "FE.13d226cb-ac28-4a06-ba0b-8b3e10249dc2",
  Chest = "FE.1b82eeb6-9690-4ef3-af75-6e76ac65051d",
  Headach = "FE.495904f5-c287-4003-89cc-ef6ec9999615",
  Joint = "FE.39ac6015-d872-4786-ae59-1cc804c0a124",
  Back = "FE.9e83bf44-d815-48b3-9fdd-3b6fb44765fc",
  UpperLimb = "FE.f1a3f3be-9ae4-4fa9-b210-070c8718c1ee",
  LowerLimb = "FE.8e87394c-d2ba-4326-a54e-ba492fe6df73",
  MuscleWeakness = "FE.52557bdf-69c6-470b-b3d8-5eb775f77f0a",
  // Ranges
  Severity = "FE.f714f36b-6c2e-47ca-b0f3-56f7a97315cd",
  Numeric = "FE.5c462191-fb3f-4fed-bc66-a322395d547c",
  // "PO.3f384b93-6a6e-4dbc-81df-26b9c2a993cb"
}

export enum NumericFeatureIds {
  Fever = "FE.9fa7031f-3a14-4fff-803e-db7dec51551d",
  SystolicBloodPressure = "FE.4200ec9d-b1c0-43df-895f-000b094e9f3c",
  DiastolicBloodPressure = "FE.1fff2702-4b62-41ff-aa44-5aa0079df6d3",
  Smoking = "FE.e0a83c43-47a8-4fc4-96ff-cda74cf07c2e",
  Weight = "FE.54cc48bd-eb23-437f-a660-8adc0fada584",
  Height = "FE.0f4407f8-f999-46b0-b455-eced51805e81",
}
